<template>
	<div class="course_bottomRight">
		<div class="lab_titleNormal">统计分析</div>
		<div class="lab_statistical">
			<div class="lab_staLabel">考核统计</div>
			<div class="lab_staCards clearfix">
				<div class="lab_staCard lab_staCardsone">
					<div class="lab_cardOneTitle">系统时长/分数</div>
					<div class="lab_cardOneInfo">系统标准用时 <span class="primaryColor">{{statisticlInfo.systemStandradTime || '-'}}分钟</span></div>
					<div class="lab_cardOneInfo">系统及格分数 <span class="primaryColor">{{statisticlInfo.systemPassScore || '-'}}分钟</span></div>
				</div>
				<div class="lab_staCard lab_staCardstwo">
					<div class="lab_cardOneTitle">我的考核统计</div>
					<div class="lab_cardTwoList">
						<div class="lab_cardTwoItem">
							<div class="lab_cardTwoItem1 primary">我的平均用时</div>
							<div class="lab_cardTwoItem2 ">
								<div class="lab_cardTwoItem2Time primaryColor">{{statisticlInfo.personalAverageTime || '-'}}分钟</div>
								<div class="lab_cardTwoItem2info" v-if="false">
									系统标准同比
									<span class="errorColor"><i class="el-icon-bottom"></i></span> 12
								</div>
							</div>
						</div>
						<div class="lab_cardTwoItem">
							<div class="lab_cardTwoItem1 warning">我的平均得分</div>
							<div class="lab_cardTwoItem2 ">
								<div class="lab_cardTwoItem2Time warningColor">{{statisticlInfo.personalAverageScore || '-'}}分</div>
								<div class="lab_cardTwoItem2info" v-if="false">
									系统标准同比
									<span class="successColor"><i class="el-icon-top"></i></span> 12
								</div>
							</div>
						</div>
						<div class="lab_cardTwoItem">
							<div class="lab_cardTwoItem1 primary">我的排名</div>
							<div class="lab_cardTwoItem2">
								<div class="lab_cardTwoItem2Time primaryColor">{{statisticlInfo.personalRanking || '-'}}</div>
								<div class="lab_cardTwoItem2info" v-if="false">
									月同比
									<span class="errorColor"><i class="el-icon-bottom"></i></span> 12
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="lab_staCard lab_staCardsthree">
					<div class="lab_staCardsthree1">全员平均用时</div>
					<div class="lab_cardTwoItem2">
						<div class="lab_cardTwoItem2Time primaryColor">{{statisticlInfo.allStafAverageTime || '-'}}分钟</div>
						<div class="lab_cardTwoItem2info" v-if="false">
							系统标准同比
							<span class="errorColor"><i class="el-icon-bottom"></i></span> 12
						</div>
					</div>
				</div>
				<div class="lab_staCard lab_staCardsthree">
					<div class="lab_staCardsthree1">全员平均得分</div>
					<div class="lab_cardTwoItem2">
						<div class="lab_cardTwoItem2Time primaryColor">{{statisticlInfo.allStafAverageScore || '-'}}分</div>
						<div class="lab_cardTwoItem2info" v-if="false">
							系统标准同比
							<span class="successColor"><i class="el-icon-top"></i></span> 12
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="lab_statistical clearfix">
			<div class="lab_staLabel">个人考核成绩统计分析</div>
			<div class="lab_staCard lab_staCardsfour">
				<div class="lab_cardOneTitle">
					<span>个人考核成绩统计分析</span>
					<span class="lab_cardOneDesc">查看用时/分数</span>
					<div class="lab_cardLabels">
						<span class="score">考核得分</span>
						<span class="time">考核用时</span>
					</div>
					<div class="lab_cardTimes">
						<el-select :popper-append-to-body='false' @change='initPersonal' v-model="limitCount" placeholder="近几次" class='center_chartSelect'>
							<el-option :label="item.name" :value="item.id" v-for='(item,index) in personalTimes'></el-option>
						</el-select>
					</div>
				</div>
				<div class="lab_cardChart" id='personal_chart'></div>
			</div>
		</div>
		<div class="lab_statistical clearfix">
			<div class="lab_staLabel">
				<span>全员考核成绩统计分析</span>
				<div class="r">
					<el-radio-group v-model="studentType" @change='studentTypeChange' size="medium">
						<el-radio-button label="用时">用时</el-radio-button>
						<el-radio-button label="得分">得分</el-radio-button>
					</el-radio-group>
				</div>
			</div>
			<div class="lab_staCard lab_staCardsfour">
				<div class="lab_cardOneTitle">
					<span>前五名近七次考核成绩</span>
					<span class="lab_cardOneDesc">查看全员考核成绩</span>
					<div class="lab_cardChecks">
						<el-checkbox-group v-model="studentRanks" @change='studentChangeRanks'>
							<el-checkbox label="1">第一名</el-checkbox>
							<el-checkbox label="2">第二名</el-checkbox>
							<el-checkbox label="3">第三名</el-checkbox>
							<el-checkbox label="4">第四名</el-checkbox>
							<el-checkbox label="5">第五名</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="lab_cardChart" id='students_chartTime' v-if="studentType == '用时'"></div>
				<div class="lab_cardChart" id='students_chartScore' v-if="studentType == '得分'"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	import { parseTime } from "@/filters/index.js"
	import { examineStatisticl, personalStatisticl, allStafStatisticl } from "@/api/simulation.js"
	export default {
		props: {
			vrDetailId: String,
			resourceId: String,
		},
		data() {
			return {
				statisticlInfo: {},
				personalChart: null,
				studentsChartTime: null,
				studentsChartScore: null,
				studentType: "用时",
				studentRanks: ['1', '2', '3', '4', '5'],
				colors: ['#3E73EF', '#2CB8F3', '#FD8601', '#7291F2', '#04CEDE'],
				numbers: ['一', '二', '三', '四', '五', ],
				personalTimes: [{
					name: '近七次',
					id: 7
				}, {
					name: '近十次',
					id: 10
				}, {
					name: '近十五次',
					id: 15
				}],
				limitCount: 7,
			}
		},
		created() {
			this.examineStatisticl();
			this.initPersonal();
			this.initStudentTime();
		},
		methods: {
			examineStatisticl() {
				examineStatisticl({
					resourceId: this.resourceId
				}).then(res => {
					this.statisticlInfo = res.data || {}
				})
			},
			handleCommand(limitCount) {
				this.limitCount = limitCount;
				this.initPersonal()
			},
			initPersonal() {
				personalStatisticl({
					resourceId: this.resourceId,
					limitCount: this.limitCount,
				}).then(res => {
					var xAxisData = [];
					var yAxisScore = [];
					var yAxisTime = [];
					if(res.code == "OK") {
						res.data.map(item => {
							xAxisData.push(parseTime(item.createTime, '{m}/{d}'));
							yAxisScore.push(item.personalScore);
							yAxisTime.push(item.personalTime);
						})
						var option = {
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									type: 'shadow'
								},
								shadowStyle: {
									shadowColor: "rgba(44,184,243,0.5)",
								},
								formatter: '{b}<br />{a0}：{c0}分<br />{a1}：{c1}分钟'
							},
							grid: {
								bottom: 30,
								top: 15,
								left: 65,
								right: 65,
							},
							xAxis: [{
								data: xAxisData,
								axisLabel: {
									show: true,
									textStyle: {
										color: '#6C7293', //更改坐标轴文字颜色
										fontSize: 14,
										lineHeight: 20,
									}
								},
							}],
							yAxis: [{
									type: 'value',
									name: '考核得分',
									axisLabel: {
										formatter: '{value}分'
									},
									axisTick: {
										lineStyle: {
											width: 0
										}
									},
								},
								{
									name: '考核用时',
									type: 'value',
									axisLabel: {
										formatter: '{value}分钟'
									},
									axisTick: {
										lineStyle: {
											width: 0
										}
									},
									splitLine: {
										show: false
									},
								}
							],
							series: [{
									name: '考核得分',
									type: 'line',
									data: yAxisScore,
									smooth: 0.2,
									color: '#2CB8F3',
									yAxisIndex: 1,
								},
								{
									name: '考核用时',
									type: 'bar',
									data: yAxisTime,
									barWidth: 20,
									color: '#3E73EF',

								}
							]
						};
						this.$nextTick(() => {
							if(!this.personalChart) {
								this.personalChart = echarts.init(document.getElementById('personal_chart'));
							}
							this.personalChart.setOption(option)
						})
					}
				})
			},
			studentTypeChange() {
				if(this.studentType == '用时' && !this.studentsChartTime) {
					if(this.studentsChartScore) {
						this.studentsChartScore.clear();
						this.studentsChartScore = null
					}
					this.initStudentTime();
				}
				if(this.studentType == '得分' && !this.studentsChartScore) {
					if(this.studentsChartTime) {
						this.studentsChartTime.clear();
						this.studentsChartTime = null
					}
					this.initStudentScore()
				}
			},
			studentChangeRanks() {
				if(this.studentType == '用时') {
					if(this.studentsChartTime) {
						this.studentsChartTime.clear();
						this.studentsChartTime = null
					}
					this.initStudentTime();
				}
				if(this.studentType == '得分') {
					if(this.studentsChartScore) {
						this.studentsChartScore.clear();
						this.studentsChartScore = null
					}
					this.initStudentScore()
				}
			},
			initStudentTime() {
				var studentRanks = this.studentRanks;
				var colors = this.colors;
				var numbers = this.numbers;
				allStafStatisticl({
					resourceId: this.resourceId,
				}).then(res => {
					var xAxisData = [];
					var yAxisScore = [];
					var yAxisTime = [];
					studentRanks.map((rank, index) => {
						yAxisTime[rank * 1 - 1] = {
							color: colors[rank * 1 - 1],
							name: '第' + numbers[rank * 1 - 1] + '名',
							data: [],
							type: 'line',
							smooth: 0.2,
						}
					})
					if(res.code == "OK") {
						res.data.map(item => {
							xAxisData.push(parseTime(item.weekDate, '{m}/{d}'));
							studentRanks.map((rank, index) => {
								var dataIndex = item.scoreNum[rank * 1 - 1];
								dataIndex = dataIndex ? {
									name: dataIndex.realName,
									value: dataIndex.personalAverageTime || 0,
								} : {
									name: '暂无',
									value: 0,
								}
								yAxisTime[rank * 1 - 1].data.push(dataIndex)
							})
						})
						var option = {
							tooltip: {
								trigger: 'axis',
								formatter: function(data) {
									var returnStr = '';
									for(var i = 0; i < data.length; i++) {
										var info = data[i];
										returnStr += info.seriesName + ' ' + info.name + '： ' + info.value + '分钟'
										if(i < data.length - 1) {
											returnStr += '<br />'
										}
									}
									return returnStr
								},
							},
							grid: {
								bottom: 30,
								top: 15,
								left: 65,
								right: 65,
							},
							xAxis: [{
								data: xAxisData,
								axisPointer: {
									type: 'line'
								},
								axisLabel: {
									show: true,
									textStyle: {
										color: '#6C7293', //更改坐标轴文字颜色
										fontSize: 14,
										lineHeight: 20,
									}
								},
							}],
							yAxis: [{
								type: 'value',
								axisLabel: {
									formatter: '{value}分钟'
								},
								axisTick: {
									lineStyle: {
										width: 0
									}
								},
							}, ],
							series: yAxisTime
						};
						this.$nextTick(() => {
							if(!this.studentsChartTime) {
								this.studentsChartTime = echarts.init(document.getElementById('students_chartTime'));
							}
							this.studentsChartTime.setOption(option)
						})
					}
				})
			},
			initStudentScore() {
				var studentRanks = this.studentRanks;
				var colors = this.colors;
				var numbers = this.numbers;
				allStafStatisticl({
					resourceId: this.resourceId,
				}).then(res => {
					var xAxisData = [];
					var yAxisScore = [];
					studentRanks.map((rank, index) => {
						yAxisScore[rank * 1 - 1] = {
							color: colors[rank * 1 - 1],
							name: '第' + numbers[rank * 1 - 1] + '名',
							data: [],
							type: 'line',
							smooth: 0.2,
						}
					})
					if(res.code == "OK") {
						res.data.map(item => {
							xAxisData.push(parseTime(item.weekDate, '{m}/{d}'));
							studentRanks.map((rank, index) => {
								var dataIndex = item.scoreNum[rank * 1 - 1];
								dataIndex = dataIndex ? {
									name: dataIndex.realName,
									value: dataIndex.personalScore || 0,
								} : {
									name: '暂无',
									value: 0,
								}
								yAxisScore[rank * 1 - 1].data.push(dataIndex)
							})
						})
						var option = {
							tooltip: {
								trigger: 'axis',
								formatter: function(data) {
									var returnStr = '';
									for(var i = 0; i < data.length; i++) {
										var info = data[i];
										returnStr += info.seriesName + ' ' + info.name + '： ' + info.value + '分'
										if(i < data.length - 1) {
											returnStr += '<br />'
										}
									}
									return returnStr
								},
							},
							grid: {
								bottom: 30,
								top: 15,
								left: 65,
								right: 65,
							},
							xAxis: [{
								data: xAxisData,
								axisPointer: {
									type: 'line'
								},
								axisLabel: {
									show: true,
									textStyle: {
										color: '#6C7293', //更改坐标轴文字颜色
										fontSize: 14,
										lineHeight: 20,
									}
								},
							}],
							yAxis: [{
								type: 'value',
								axisLabel: {
									formatter: '{value}分'
								},
								axisTick: {
									lineStyle: {
										width: 0
									}
								},
							}],
							series: yAxisScore
						};
						this.$nextTick(() => {
							if(!this.studentsChartScore) {
								this.studentsChartScore = echarts.init(document.getElementById('students_chartScore'));
							}
							this.studentsChartScore.setOption(option)
						})
					}
				})
			},
		},
	}
</script>